import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { FaUsers, FaBoxOpen } from "react-icons/fa";
import { MdOutlineInventory2 } from "react-icons/md";
import { FaExternalLinkAlt } from "react-icons/fa";

function More() {
  return (
    <div className="min-h-screen p-4 md:p-8">
      {/* Quick Actions */}
      <div className="grid grid-cols-2 gap-4 mb-6">
        <Link
          to="/attendance"
          className="bg-primary text-white py-4 rounded-lg font-medium shadow-md text-center"
        >
          Attendance Management
          <FaExternalLinkAlt className="inline-block ml-2" />
        </Link>
        <Link
          to="/payroll"
          className="bg-primary text-white py-4 rounded-lg font-medium shadow-md text-center"
        >
          Manage Payroll
          <FaExternalLinkAlt className="inline-block ml-2" />
        </Link>
      </div>

      {/* Stats */}
      <div className="space-y-4 mb-8">
        <div className="bg-white rounded-lg shadow p-4 flex justify-between items-center">
          <div className="flex items-center gap-3">
            <FaUsers className="text-primary" />
            <span className="text-sm font-semibold">All Customers</span>
          </div>
          <div>
            <span className="font-bold">75</span>
            <span className="font-bold text-primary">
              {" "}
              <FaExternalLinkAlt className="text-primary inline-block ml-2 t" />
            </span>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-4 flex justify-between items-center">
          <div className="flex items-center gap-3">
            <FaBoxOpen className="text-primary" />
            <span className="text-sm font-semibold">All Items</span>
          </div>
          <div>
            <span className="font-bold">110</span>
            <span className="font-bold">
              {" "}
              <FaExternalLinkAlt className="inline-block ml-2 text-primary" />
            </span>
          </div>
        </div>
        <Link to="/cost-price" className="block">
          <div className="bg-white rounded-lg shadow p-4 flex justify-between items-center">
            <div className="flex items-center gap-3">
              <MdOutlineInventory2 className="text-primary" />
              <span className="text-sm font-semibold">
                Stock Value Cost Price
              </span>
            </div>
            <div>
              <span className="font-bold">110</span>
              <span className="font-bold">
                {" "}
                <FaExternalLinkAlt className="inline-block ml-2 text-primary" />
              </span>
            </div>
          </div>
        </Link>
        <Link to="/selling-price" className="block">
          <div className="bg-white rounded-lg shadow p-4 flex justify-between items-center">
            <div className="flex items-center gap-3">
              <MdOutlineInventory2 className="text-primary" />
              <span className="text-sm font-semibold">
                Stock Value Selling Price
              </span>
            </div>
            <div>
              <span className="font-bold">110</span>
              <span className="font-bold">
                {" "}
                <FaExternalLinkAlt className="text-primary inline-block ml-2" />
              </span>
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
}

export default More;
